import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateRuleSet = api(async function updateRuleSet({ id, data }) {
    return mutate(
        gql`
            mutation UpdateRuleSet($id: String!, $data: RuleSetInput!) {
                updateRuleSet(id: $id, data: $data)
            }
        `,
        { id, data },
        { returns: "updateRuleSet" }
    )
})
